var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1020,
    height: 16,
    viewBox: "0 0 1020 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.10359,
    cy: 7.73784,
    rx: 7.10359,
    ry: 7.73784,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.4512,
    cy: 7.73784,
    rx: 7.10359,
    ry: 7.73784,
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 161.803,
    cy: 7.73784,
    rx: 7.10359,
    ry: 7.73784,
    fill: "white"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 239.154,
    cy: 7.73784,
    rx: 7.10359,
    ry: 7.73784,
    fill: "white"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 316.502,
    cy: 7.73784,
    rx: 7.10359,
    ry: 7.73784,
    fill: "white"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 393.858,
    cy: 7.73784,
    rx: 7.10359,
    ry: 7.73784,
    fill: "white"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 471.205,
    cy: 7.73784,
    rx: 7.10359,
    ry: 7.73784,
    fill: "white"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 548.553,
    cy: 7.73784,
    rx: 7.10359,
    ry: 7.73784,
    fill: "white"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 625.908,
    cy: 7.73784,
    rx: 7.10359,
    ry: 7.73784,
    fill: "white"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 703.256,
    cy: 7.73784,
    rx: 7.10359,
    ry: 7.73784,
    fill: "white"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 780.607,
    cy: 7.73784,
    rx: 7.10359,
    ry: 7.73784,
    fill: "white"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 857.955,
    cy: 7.73784,
    rx: 7.10359,
    ry: 7.73784,
    fill: "white"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 935.303,
    cy: 7.73784,
    rx: 7.10359,
    ry: 7.73784,
    fill: "white"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1012.66,
    cy: 7.73784,
    rx: 7.10359,
    ry: 7.73784,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarImage);
export default __webpack_public_path__ + "static/media/calendarImage.01f5f55324ceee1231d8b95480e9440b.svg";
export { ForwardRef as ReactComponent };